import Component from './Component'

export default class ChartHost extends Component {

	static _type = 'ChartHost'

	tether () {
		super.tether()
		this.cht = new Chart(this.base, this.params)
	}

    destroy() {
		this.cht.destroy()
        super.destroy()
    }
}
